import { VariableValueSimulator } from '../api/variable-value-simulator';

export class RandomValueSimulator implements VariableValueSimulator {
  constructor(
    private options: {
      min: number;
      max: number;
      float?: boolean;
    }
  ) {}

  generateNextValue(): number {
    const value =
      Math.random() * (this.options.max - this.options.min) + this.options.min;
    if (this.options.float) {
      return value;
    } else {
      return Math.floor(value);
    }
  }
}
